import { render, staticRenderFns } from "./project-information.html?vue&type=template&id=0e248fc6&"
import script from "./ProjectInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports